import React from 'react';
import { withRouter } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

import Button from '../components/Button';

import heroImage from '../../assets/hero-bg@3x.png';
import heroImageDesktop from '../../assets/congrats-bg.svg';
import tickImage from '../../assets/tick-blanco-icn.svg';
import tickOrangeImage from '../../assets/tick-orange-icn.svg';
import horarioImage from '../../assets/horario.svg';
import tarjetaImage from '../../assets/tarjeta.svg';
import IconLocation from './../../assets/icon-location.svg';
import IconPhone from './../../assets/phone.svg';

import useStore from '../store';
import useMatchMedia from '../useMatchMedia';

import { cards } from '../data';
import {
  getPickupInfo,
  clearSessionStorage,
  redirectToLanding,
  breakpoints,
  colors,
} from '../config';

const Success = props => {
  const [{ selectedGroup, selectedCard }, setStore] = useStore();
  const isDesktop = useMatchMedia(`(min-width: ${breakpoints.md})`);
  const { state } = useStateMachine(updateAction);

  const pickupInfo = getPickupInfo(state?.data?.pickup || 'UES Centro', state?.data?.zona);

  function getCards(cardId) {
    return cards.find(card => card.id === cardId);
  }

  function getCardTypes(cardId, types) {
    return types.find(card => card.id === cardId);
  }

  let group = getCards(selectedGroup);
  let card = getCardTypes(selectedCard, group?.types);
  const cardImage = card?.image;

  function handleExit() {
    clearSessionStorage();
    redirectToLanding();
  }

  const AlertIcon = ({ size = 30, color = 'currentColor' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30">
      <path
        fill={color}
        d="M24.625 26.656c1.417 0 2.484-.614 3.203-1.843.719-1.23.724-2.459.016-3.688L17.28 2.656c-.25-.437-.583-.765-1-.984-.416-.219-.843-.328-1.281-.328-.438 0-.865.11-1.281.328-.417.219-.75.547-1 .984L2.156 21.125c-.708 1.23-.703 2.458.016 3.688.719 1.229 1.786 1.843 3.203 1.843h19.25zm0-1.312H5.375c-.23 0-.443-.032-.64-.094-.199-.063-.391-.146-.579-.25-.166-.104-.323-.23-.468-.375-.146-.146-.271-.302-.376-.469-.104-.166-.182-.349-.234-.547C3.026 23.411 3 23.21 3 23c0-.208.026-.411.078-.61.052-.197.13-.39.235-.578l10.562-18.5c.167-.291.37-.473.61-.546.239-.073.41-.11.515-.11.104 0 .276.037.516.11.24.073.442.255.609.546l10.563 18.5c.104.188.182.38.234.579.052.198.078.4.078.609 0 .208-.026.411-.078.61-.052.197-.13.38-.235.546-.104.167-.229.323-.375.469-.145.146-.302.27-.468.375-.188.104-.38.188-.578.25-.198.063-.412.094-.641.094zm-8.969-6.688v-8h-1.312v8h1.312zM15 22c.27 0 .505-.099.703-.297.198-.198.297-.432.297-.703 0-.27-.099-.505-.297-.703-.198-.198-.432-.297-.703-.297-.27 0-.505.099-.703.297-.198.198-.297.432-.297.703 0 .27.099.505.297.703.198.198.432.297.703.297z"
      />
    </svg>
  );

  return (
    <>
      <div className="success-art" />

      <div>
        {isDesktop ? (
          <>
            <div className="success-hero-desktop">
              <div className="error-msg">
                <h1>Ups, no es posible procesar tu solicitud.</h1>
                <div className="purple-box">
                  <span>
                    <AlertIcon />
                  </span>
                  <p>
                    De acuerdo a la politíca vigente del Banco no es posible procesar tu solicitud
                    por este canal.
                  </p>
                </div>
                <div className="white-box">
                  <p>Por más información podés contactarnos en nuestros canales digitales:</p>
                  <ul>
                    <li>
                      <img src={IconPhone} alt="Icono" />
                      <a href="tel:1784">Llamá al 1784</a>
                    </li>
                    <li>
                      <img src={IconLocation} alt="Icono" />
                      <a href="https://www.itau.com.uy/inst/sucursales.html" target="_blank">
                        Ver sucursales
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="success-content">
                  <div className="form-actions">
                    <Button block onClick={handleExit} id="success-button">
                      Terminar
                    </Button>
                  </div>
                </div>
              </div>
              <motion.div
                initial={{ x: 200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1, ease: 'anticipate' }}
              >
                <div className="success-image">
                  <img src={cardImage} alt="" />
                </div>
              </motion.div>
            </div>
          </>
        ) : (
          <>
            <div className="success-hero">
              <div className="success-image">
                <img src={cardImage} alt="" />
              </div>
              <div className="error-msg">
                <h1>Ups, no es posible procesar tu solicitud.</h1>
                <div className="purple-box">
                  <span>
                    <AlertIcon />
                  </span>
                  <p>
                    De acuerdo a la politíca vigente del Banco no es posible procesar tu solicitud
                    por este canal.
                  </p>
                </div>
                <div className="white-box">
                  <p>Por más información podés contactarnos en nuestros canales digitales:</p>
                  <ul>
                    <li>
                      <img src={IconPhone} alt="Icono" />
                      <a href="tel:1784">Llamá al 1784</a>
                    </li>
                    <li>
                      <img src={IconLocation} alt="Icono" />
                      <a href="https://www.itau.com.uy/inst/sucursales.html" target="_blank">
                        Ver sucursales
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="success-content">
              <div className="form-actions">
                <Button block onClick={handleExit} id="success-button">
                  Terminar
                </Button>
              </div>
            </div>
          </>
        )}
      </div>

      <style jsx>{`
        .success-art {
          background-image: url(${heroImageDesktop});
          width: 800px;
          height: 1000px;
          background-position: top left;
          background-repeat: no-repeat;
          position: absolute;
          top: -633px;
          right: -15%;
          display: none;
        }

        @media screen and (min-width: 1400px) {
          .success-art {
            right: 3%;
          }
        }

        @media screen and (min-width: ${breakpoints.md}) {
          .success {
            max-width: 768px;
            margin: 0 auto;
          }

          .success-art {
            display: block;
          }
        }

        :global(.art) {
          display: none;
        }

        :global(#itau-tc .container) {
          width: 100% !important;
        }

        .success-hero {
          background-image: url(${heroImage});
          background-position: center bottom;
          background-repeat: no-repeat;
          background-size: cover;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 32px 32px 16% 32px;
          align-items: center;
        }

        @media screen and (max-width: ${breakpoints.md}) {
          .success-hero {
            background-image: none;
            padding-bottom: 0;
          }
        }

        .success-image {
          overflow: hidden;
          border-radius: 12px;
          margin-bottom: 32px;
          max-width: 420px;
          box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.08), 0 2px 5px 0 rgba(43, 43, 43, 0.05),
            0 12px 30px 0 rgba(168, 90, 12, 0.2);
        }

        .success-image img {
          width: 100%;
          height: auto;
          vertical-align: middle;
        }

        @media screen and (max-width: ${breakpoints.md}) {
          .success-content {
            padding: 32px;
          }
        }

        ul {
          list-style: none;
          margin: 0;
          margin-bottom: 48px;
          padding: 0;
        }

        @media screen and (min-width: ${breakpoints.md}) {
          ul {
            background-color: #fff;
            border-radius: 4px;
            padding: 32px 24px;
            display: flex;
          }

          ul li {
            flex: 1 0 0%;
            margin-bottom: 0;
          }

          ul li + li {
            margin-left: 32px;
          }
        }

        li {
          background-position: left 1px;
          background-repeat: no-repeat;
          margin: 0;
          margin-bottom: 38px;
          padding-left: 38px;
          position: relative;
        }

        .item-tarjeta {
          background-image: url(${tarjetaImage});
        }

        .item-horario {
          background-image: url(${horarioImage});
        }

        .success-hero h1 {
          display: flex;
          font-size: 22px;
          line-height: 1.35;
          margin: 0;
          align-items: center;
        }

        h1 span {
          flex: 1 0 0%;
          margin-left: 20px;
        }

        .success-hero-desktop {
          display: flex;
          justify-content: space-between;
          z-index: 100;
          position: relative;
          padding-top: 52px;
        }

        .success-hero-desktop h1 {
          font-weight: 900;
          font-family: ${colors.baseFontDisplay};
          font-size: 32px;
          display: flex;
          align-items: center;
          line-height: 1.2;
        }

        .success-hero-desktop .success-image {
          max-width: 330px;
          margin-bottom: 16px;
          box-shadow: 0 64px 64px 0 rgba(89, 76, 58, 0.05), 0 32px 32px 0 rgba(120, 109, 61, 0.05),
            0 16px 16px 0 rgba(82, 69, 55, 0.05), 0 8px 8px 0 rgba(125, 109, 72, 0.05),
            0 4px 4px 0 rgba(125, 114, 64, 0.05), 0 2px 2px 0 rgba(115, 102, 63, 0.05);
        }

        h2 {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 32px;
          margin-top: 0;
        }

        @media screen and (min-width: ${breakpoints.md}) {
          h2 {
            margin-bottom: 24px;
          }
        }

        h3 {
          color: ${colors.black};
          font-size: 18px;
          font-weight: 800;
          margin-bottom: 10px;
          margin-top: 0;
          line-height: 1.5;
        }

        p {
          margin-bottom: 10px;
          margin-top: 0;
        }

        .tip {
          color: ${colors.textMuted};
          font-size: 14px;
        }

        .tip strong {
          color: ${colors.orange};
          font-weight: 800;
          text-transform: uppercase;
        }

        .error-msg {
          width: 50%;
        }

        @media screen and (max-width: ${breakpoints.md}) {
          .error-msg {
            width: 100%;
          }
        }

        .purple-box {
          color: white;
          background-color: #531e6d;
          border-radius: 4px;
          padding: 22px;
          display: flex;
          gap: 20px;
          align-item: center;
        }

        @media screen and (max-width: ${breakpoints.md}) {
          .purple-box {
            margin-top: 18px;
          }
        }

        .purple-box p {
          margin: 0;
        }

        .purple-box span {
          width: 60px;
          transform: translateY(4px);
        }

        .white-box {
          padding: 32px;
          margin: 32px 0 46px;
          border-radius: 4px;
          background-color: white;
          box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.1);
        }

        @media screen and (max-width: ${breakpoints.md}) {
          .white-box {
            padding: 16px;
          }
        }

        .white-box ul {
          display: block;
          padding: 0;
          margin: 0;
        }

        .white-box ul li {
          margin: 0;
          padding: 0;
          display: flex;
          align-items: center;
        }

        .white-box ul li:nth-child(1) {
          margin-bottom: 22px;
        }

        .white-box ul li a {
          color: #5d8eb1;
          text-decoration: none;
        }

        .white-box ul li img {
          width: 30px;
          height: 30px;
          margin-right: 8px;
        }
      `}</style>
    </>
  );
};

export default withRouter(Success);
